import {
  DefaultTestSlotLocationAddress,
  SlotLocationAddress,
} from './slotLocationAddress';

export interface LocationSummary {
  locationId?: string;
  locationName?: string;
  locationAddress?: SlotLocationAddress;
}

///////////////////////////////////////////////
// defaults for testing
export const DefaultTestProviderLocations = new Array(2)
  .fill(undefined)
  .map((item, index) => ({
    locationId: `location${index}`,
    locationName: `Location ${index}`,
    locationAddress: DefaultTestSlotLocationAddress,
  }));
